export default [
    'T&M',
    'FXP',
    'T&E',
    'IT',
    'Business',
    'FMS'
]
export const resourceTypesEnums = Object.freeze(({'T&M': 0, 'FXP': 1, 'T&E': 2, 'IT': 3, 'Business': 4, 'FMS': 5}))